"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCertificate = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M60.85 20.41a1 1 0 0 0 1-1v-6.82a4.86 4.86 0 0 0-4.9-4.81H17.48a4.79 4.79 0 0 0-4.87 4.81v43.62a4.91 4.91 0 0 0 4.87 4.94h9.58v6.77a1 1 0 0 0 1.41.87l4.77-2.39L38 68.8a1 1 0 0 0 1.41-.87v-6.78H56.9a4.91 4.91 0 0 0 4.9-4.91v-6.87a1 1 0 0 0-1-1H54v-28zm-1-7.82v5.87H54v-5.8a2.93 2.93 0 0 1 5.86-.07zM38 52.09a1 1 0 0 0-.34.3 6.88 6.88 0 1 1 .34-.3zm-.52 14.25l-3.79-1.9a1 1 0 0 0-.87 0L29 66.34V54.81a8.77 8.77 0 0 0 8.46 0zm2-12.92a8.79 8.79 0 1 0-12.37-.09v5.87h-9.63a3 3 0 0 1-2.92-3V12.59a2.86 2.86 0 0 1 2.92-2.86H53a4.85 4.85 0 0 0-1 2.92v43.56a4.9 4.9 0 0 0 1 3H39.38zm20.44-3.07v5.86a3 3 0 0 1-3 3 2.94 2.94 0 0 1-2.91-3v-5.86zm0 0"
  }), _react["default"].createElement("path", {
    d: "M33.29 42.26a4.88 4.88 0 1 0 4.88 4.88 4.89 4.89 0 0 0-4.88-4.88zm0 7.81a2.93 2.93 0 1 1 2.93-2.93 2.93 2.93 0 0 1-2.93 2.93zm0 0M46.33 27.57h-26a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2zm0 0M42.43 31.47H24.2a1 1 0 1 0 0 2h18.23a1 1 0 0 0 0-2zm0 0M46.33 23.66h-3.9a1 1 0 1 0 0 2h3.91a1 1 0 0 0 0-2zm0 0M20.29 25.61h18.23a1 1 0 0 0 0-2H20.29a1 1 0 0 0 0 2zm0 0M23.58 20.22a1 1 0 0 0 1.42-.17l2.27-2.92L29.49 20A1 1 0 0 0 31 20l2.27-2.91L35.56 20a1 1 0 0 0 1.54 0l2.27-2.91L41.64 20a1 1 0 0 0 1.54-1.2l-3-3.91a1 1 0 0 0-1.54 0l-2.27 2.91-2.27-2.91a1 1 0 0 0-1.54 0l-2.27 2.91L28 14.95a1 1 0 0 0-1.54 0l-3 3.91a1 1 0 0 0 .17 1.37zm0 0"
  })),
  height: undefined,
  width: undefined
});
IconCertificate.displayName = 'IconCertificate';
var _default = IconCertificate;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/certificate.js
// module id = 551
// module chunks = 0